// ============================================================================
// PageState — tiny shared loading / error blocks for data-backed pages, in the
// Pulse language. Used by the dashboard (and reusable by per-page agents).
// ============================================================================
import { useTranslation } from "react-i18next";
import { Button, Card } from "../components";

export function LoadingBlock({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <Card className="flex items-center justify-center gap-3 py-16">
      <span
        className="h-6 w-6 animate-spin rounded-full border-[3px] border-line border-t-coral"
        role="status"
      />
      <span className="font-display text-sm font-bold text-body-soft">
        {label ?? t("common.loading")}
      </span>
    </Card>
  );
}

export function ErrorBlock({ onRetry }: { onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <Card className="space-y-3 py-12 text-center">
      <h3 className="font-display text-lg font-bold text-body">
        {t("common.error")}
      </h3>
      <p className="text-body-soft">{t("common.errorBlurb")}</p>
      {onRetry && (
        <div className="flex justify-center pt-2">
          <Button variant="ghost" size="sm" onClick={onRetry}>
            {t("actions.retry")}
          </Button>
        </div>
      )}
    </Card>
  );
}
